export default __webpack_public_path__ + "static/media/bariyelia1.10619de3.jpg";